var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import * as classNames from 'classnames';
import * as padLeft from 'pad-left';
import ListAthleteItemFlag from './ListAthletesItemFlag';
import ListAthletesItemGender from './ListAthletesItemGender';
import ListAthletesItemStatus from './ListAthletesItemStatus';
import ListAthletesItemSummated from './ListAthletesItemSummated';
import ListAthletesItemAthleteScoreRoutes from './ListAthletesItemAthleteScoreRoutes';
var selfStyles = require('./styles.scss');
var ListAthletesItem = (function (_super) {
    __extends(ListAthletesItem, _super);
    function ListAthletesItem(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            prevRank: props.rank || 0,
            diffRank: 0,
            cssToggle: true,
        };
        return _this;
    }
    ListAthletesItem.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.rank &&
            nextProps.rank !== this.state.prevRank) {
            this.setState({
                prevRank: nextProps.rank,
                diffRank: nextProps.rank - (this.props.rank || 0),
                cssToggle: !this.state.cssToggle,
            });
        }
        else if (nextProps.athleteScore &&
            this.props.athleteScore &&
            nextProps.athleteScore.updatedAt !== this.props.athleteScore.updatedAt) {
            this.setState({
                prevRank: nextProps.rank || 0,
                diffRank: 0,
            });
        }
    };
    ListAthletesItem.prototype.render = function () {
        return (React.createElement("div", { className: classNames(selfStyles.athleteItem, (_a = {}, _a[selfStyles.athleteItemActive] = this.props.isActive, _a)), onClick: this.props.handleClickAthleteItem },
            React.createElement("div", { className: selfStyles.athleteItemRow },
                this.props.hideRank
                    ? null
                    : (React.createElement("div", { className: selfStyles.athleteItemInfoLeft },
                        React.createElement("span", { className: selfStyles.athleteRankPrefix },
                            React.createElement("span", { className: classNames(selfStyles.athleteRankArrow, (_b = {},
                                    _b[selfStyles.athleteRankArrowUp] = this.state.diffRank < 0,
                                    _b[selfStyles.athleteRankArrowDown] = this.state.diffRank > 0,
                                    _b[selfStyles.athleteRankArrowFadeOne] = this.state.cssToggle,
                                    _b[selfStyles.athleteRankArrowFadeTwo] = !this.state.cssToggle,
                                    _b)) }),
                            "#"),
                        React.createElement("span", { className: selfStyles.athleteRank }, this.props.rank))),
                React.createElement("div", { className: selfStyles.athleteItemInfoCenter },
                    React.createElement(ListAthleteItemFlag, { countryCode: this.props.athlete.countryCode, countryState: this.props.athlete.countryState }),
                    React.createElement("span", { className: selfStyles.athleteBib },
                        this.props.round.code,
                        padLeft(this.props.bibNumber, 3, '0')),
                    React.createElement(ListAthletesItemGender, { gender: this.props.athlete.gender }),
                    React.createElement("span", { className: selfStyles.athleteName }, this.props.athlete.name)),
                React.createElement("div", { className: selfStyles.athleteItemInfoRight },
                    React.createElement(ListAthletesItemStatus, { isActive: this.props.isActive, athleteScore: this.props.athleteScore }),
                    !this.props.isTeam && !this.props.hideAthleteScoreRoute &&
                        React.createElement(ListAthletesItemSummated, { scoreSystemKey: this.props.round.scoreSystem, athleteScore: this.props.athleteScore }))),
            !!this.props.athlete.affiliation && (React.createElement("div", { className: selfStyles.athleteItemRow, style: { marginTop: -5 } },
                this.props.hideRank
                    ? null
                    : (React.createElement("div", { className: selfStyles.athleteItemInfoLeft, style: { visibility: 'hidden' } },
                        React.createElement("span", { className: selfStyles.athleteRankPrefix }, "#"),
                        React.createElement("span", { className: selfStyles.athleteRank }, this.props.rank))),
                React.createElement("div", { className: selfStyles.athleteItemInfoCenter },
                    React.createElement("span", { className: selfStyles.athleteAffiliation }, this.props.athlete.affiliation)))),
            (this.props.isPlatform || !this.props.hideAthleteScoreRoute) &&
                React.createElement("div", { className: selfStyles.athleteItemRow },
                    React.createElement(ListAthletesItemAthleteScoreRoutes, { isPlatform: this.props.isPlatform, width: this.props.athleteScoreRouteItemWidth, round: this.props.round, athleteScoreRoutes: this.props.athleteScoreRoutes, handleChangeAthleteScoreRoute: this.props.handleChangeAthleteScoreRoute }))));
        var _a, _b;
    };
    return ListAthletesItem;
}(React.Component));
export default ListAthletesItem;



//////////////////
// WEBPACK FOOTER
// ./src/imports/components/Scoreboard/components/ListAthletesItem.tsx
// module id = 409
// module chunks = 0